// Priority: logged-in Shopify order count > cached localStorage > Klaviyo kx lookup.
class CustomerSegment {
	static COOKIE_NAME = 'kl_customer_segment';
	static STORAGE_KEY = 'kl_customer_segment';
	static MAX_AGE_MS = 24 * 60 * 60 * 1000;
	static WORKER_URL = 'https://square-morning-54ed.femme-devine.workers.dev/';
	static SEGMENT_PAGES = {
		returning: ['returning-cusomter-via-klavyio-check'],
		new: [],
	};

	static init() {
		if (typeof window.__mnOrdersCount === 'number') {
			this.persist(window.__mnOrdersCount > 0 ? 'returning' : 'new');
			return;
		}

		const stored = this.readStorage();
		if (stored && Date.now() - stored.updatedAt < this.MAX_AGE_MS) {
			this.setCookie(stored.segment);
			return;
		}

		const kx = this.getKx();
		if (!kx) {
			this.setCookie(stored ? stored.segment : 'unknown');
			return;
		}

		this.fetchSegment(kx)
			.then((segment) => this.persist(segment))
			.catch((error) => {
				console.error('customer-segment: fetch failed', error);
				this.setCookie(stored ? stored.segment : 'unknown');
			});
	}

	static getKx() {
		const fromUrl = new URLSearchParams(window.location.search).get('_kx');
		if (fromUrl) return fromUrl;

		const raw = this.getCookie('__kla_id');
		if (!raw) return null;

		try {
			const decoded = JSON.parse(atob(raw));
			return decoded.$exchange_id || null;
		} catch (error) {
			console.error('customer-segment: failed to decode __kla_id', error);
			return null;
		}
	}

	static async fetchSegment(kx) {
		const response = await fetch(`${this.WORKER_URL}?kx=${encodeURIComponent(kx)}`);
		if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
		const data = await response.json();
		console.log('data from klavyio', data);
		if (!data.profile_found) return 'unknown';
		return data.total_orders > 0 ? 'returning' : 'new';
	}

	static persist(segment) {
		try {
			localStorage.setItem(this.STORAGE_KEY, JSON.stringify({ segment, updatedAt: Date.now() }));
		} catch (error) {
			console.error('customer-segment: localStorage write failed', error);
		}
		this.setCookie(segment);
	}

	static readStorage() {
		try {
			const raw = localStorage.getItem(this.STORAGE_KEY);
			return raw ? JSON.parse(raw) : null;
		} catch (error) {
			console.error('customer-segment: localStorage read failed', error);
			return null;
		}
	}

	static setCookie(segment) {
		document.cookie = `${this.COOKIE_NAME}=${segment}; path=/; max-age=${this.MAX_AGE_MS / 1000}; SameSite=Lax; Secure`;
		this.activatePages(segment);
	}

	static activatePages(segment) {
		const pageApiNames = this.SEGMENT_PAGES[segment] || [];
		if (!pageApiNames.length) return;

		window.ablyft = window.ablyft || [];
		pageApiNames.forEach((pageApiName) => {
			window.ablyft.push({ eventType: 'activatePage', pageApiName });
		});
	}

	static getCookie(name) {
		const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
		return match ? decodeURIComponent(match[1]) : null;
	}
}

CustomerSegment.init();

document.addEventListener('visitorConsentCollected', (event) => {
	// Klavyio cookie is set after consent is collected
	setTimeout(() => CustomerSegment.init(), 1500);
});
